import {
  type RouteObject,
} from "react-router";
import UserActionList from "UserAction/List/App";

declare let viewModel: any;

export const userActionRoute: RouteObject = {
  path: "useraction",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: UserActionList,
  }]
};